import { fieldValidationMessages } from 'app/constants';

export const defaultValues = {
  email: '',
  password: '',
  rememberMe: false,
};

export const errorMessages = {
  errors: {
    password: {
      required: fieldValidationMessages.REQUIRED_PASSWORD,
    },
    email: {
      required: fieldValidationMessages.REQUIRED_EMAIL,
    },
  },
};
